import Loadable from '../../../components/loadable';

const ContactPrivacyPolicies = Loadable({
  loader: () => import('react/pages/contacts/privacy_policies'),
  type: 'block',
});

angular.module('gym').value('ContactPrivacyPolicies', ContactPrivacyPolicies);
